import React from "react";
import { Eye } from "lucide-react";

// Founder-only "view the console as another role" preview switcher. Purely a
// UI preview: it re-scopes the visible menus via /api/policies/{role} ui_flags;
// real server-side permissions are unchanged. Lets a founder see exactly what
// a Sales / Trial user sees without a separate login.
const ROLE_OPTIONS = [
  { value: "", label: "Founder (your view)" },
  { value: "sales_manager", label: "Sales Manager" },
  { value: "sales_person", label: "Sales" },
  { value: "trial_user", label: "Trial" },
  { value: "campaign_user", label: "Campaign" },
  { value: "lite_public", label: "Lite" },
];

export default function RolePreviewSwitcher({ value, onChange }) {
  return (
    <label className="flex items-center gap-2 text-[11px] tracking-[0.12em] uppercase text-white/70" data-testid="role-preview-switcher">
      <Eye size={13} className="text-[#A179FA]" />
      <span className="hidden sm:inline">View as</span>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value || null)}
        data-testid="role-preview-select"
        className="bg-black border border-white/30 hover:border-white/60 text-white text-[11px] tracking-[0.08em] uppercase px-2.5 py-2 focus:outline-none focus:border-[#7737F6] cursor-pointer"
      >
        {ROLE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value} className="bg-black">{o.label}</option>
        ))}
      </select>
    </label>
  );
}
